import {AbstractControl} from '@angular/forms';
import { countryConfig } from 'src/country-config/country-config';

export function zeroValidator(control: AbstractControl) {
    const parsedValue: any = parseInt(control.value, 10).toString();
    const valid = (Number.isNaN(parsedValue) || parsedValue === '0') ? false : (parsedValue.length === control.value.length);
    if ( countryConfig.allowIdStartsWithZero ) {
        return null;
    } else {
        return valid ? null : {startsWithZero: !valid};
    }
}
